// shared-components/hooks/useBreakpoint.js
import { useState, useEffect } from 'react';

export const BREAKPOINTS = {
  mobile: 768, // Matches --breakpoint-mobile in tokens.css
  tablet: 1024, // Matches --breakpoint-tablet in tokens.css
};

export const useBreakpoint = () => {
  const getBreakpoint = (width) => {
    if (width <= BREAKPOINTS.mobile) return 'mobile';
    if (width <= BREAKPOINTS.tablet) return 'tablet';
    return 'desktop';
  };

  const [breakpoint, setBreakpoint] = useState(() => {
    if (typeof window === 'undefined') return 'desktop'; // SSR fallback
    return getBreakpoint(window.innerWidth);
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    breakpoint,
    isMobile: breakpoint === 'mobile',
    isTablet: breakpoint === 'tablet',
    isDesktop: breakpoint === 'desktop',
  };
};

